import { useMutation, UseMutationResult, useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';

import { ActiveInteractionTemplate, InteractionTemplate, TriggerPointTypeListResponse } from '../@types/interaction.type';
import { createInteractionRule, getAllInteractionTemplates, getAllTriggerPointTypes, updateInteractionRule } from '../api/interaction';
import { getAllActiveInteractionTemplates } from '../api/interactions';
import { ActiveInteractionTemplateKey, InteractionsRulesConfigsKey, InteractionsTrigerPointTypeKey, InteractionTemplateKey } from '../configs/interactions-rules';

export const useCreateInteractionRule = (): UseMutationResult => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (data: any) => {
      const queryResult = await createInteractionRule(data);
      return queryResult;
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [InteractionsRulesConfigsKey]
      });
    }
  });
};
  
export const useUpdateInteractionRule = (): UseMutationResult => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => updateInteractionRule(data.id, data),

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [InteractionsRulesConfigsKey]
      });
    }
  });
};

export const useGetAllInteractionTemplates = (): UseQueryResult<InteractionTemplate> => {
  return useQuery({
    queryKey: [InteractionTemplateKey],
    queryFn: () => getAllInteractionTemplates()
  });
};

export const useGetAllTriggerPointTypes = (): UseQueryResult<TriggerPointTypeListResponse[]> => {
  return useQuery({
    queryKey: [InteractionsTrigerPointTypeKey],
    queryFn: () => getAllTriggerPointTypes()
  });
};

export const useGetAllActiveInteractionTemplates = (): UseQueryResult<ActiveInteractionTemplate[]> => {
  return useQuery({
    queryKey: [ActiveInteractionTemplateKey],
    queryFn: () => getAllActiveInteractionTemplates()
  });
};